import React from 'react';
import {Button, Tooltip, Space, Select, Checkbox} from 'antd';
import {CheckOutlined, CloseOutlined} from '@ant-design/icons';

interface PipelineToolbarProps {
    pipelineOptions: { value: any; label: string }[] | undefined;
    displayPipelineID: any;
    displayComparePipelineID: any;
    compareMode: boolean;
    dataPipeline: any;
    handlePipelineChange: (value: number | "latest") => void;
    setCompareMode: (value: boolean) => void;
    setComparePipelineID: (value: "latest" | number) => void;
    toggleAppliedStatus: () => void;
    triggerAIProcessor: () => void;
    retriggerAIProcessor: () => void;
}

const PipelineToolbar = ({
    pipelineOptions,
    displayPipelineID,
    displayComparePipelineID,
    compareMode,
    dataPipeline,
    handlePipelineChange,
    setCompareMode,
    setComparePipelineID,
    toggleAppliedStatus,
    triggerAIProcessor,
    retriggerAIProcessor,
}: PipelineToolbarProps) => {
    return (
        <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
            <Space wrap size="middle" style={{ width: '100%', justifyContent: 'space-between' }}>
                <Space wrap size="small">
                    <Space size="small">
                        <span>Pipeline:</span>
                        {
                            pipelineOptions &&
                            <Select
                                value={displayPipelineID}
                                style={{ minWidth: 120 }}
                                dropdownStyle={{ fontSize: 14 }}
                                options={pipelineOptions}
                                onChange={
                                    // @ts-ignore
                                    (value) => handlePipelineChange(value)
                                }
                            />
                        }
                    </Space>
                    <Space size="small">
                        <Checkbox checked={compareMode} onChange={(e) => setCompareMode(e.target.checked)}>
                            compare with
                        </Checkbox>
                        {
                            pipelineOptions &&
                            <Select
                                placeholder="Select compare pipeline"
                                value={displayComparePipelineID}
                                style={{ minWidth: 120 }}
                                dropdownStyle={{ fontSize: 14 }}
                                options={pipelineOptions}
                                disabled={!compareMode}
                                onChange={
                                    // @ts-ignore
                                    (value) => setComparePipelineID(value)
                                }
                            />
                        }
                    </Space>
                </Space>

                <Space wrap size="small">
                    <Tooltip title={dataPipeline?.applied ? "Mark as not applied" : "Mark as applied"}>
                        <Button
                            onClick={toggleAppliedStatus}
                            type="default"
                            disabled={!dataPipeline}
                            style={{
                                backgroundColor: !dataPipeline ? '#f5f5f5' : (dataPipeline?.applied ? '#52c41a' : 'white'),
                                borderColor: !dataPipeline ? '#d9d9d9' : (dataPipeline?.applied ? '#52c41a' : '#d9d9d9'),
                                color: !dataPipeline ? '#bfbfbf' : (dataPipeline?.applied ? 'white' : 'black'),
                                opacity: !dataPipeline ? 0.5 : 1
                            }}
                            icon={dataPipeline?.applied ? <CheckOutlined /> : <CloseOutlined />}
                        >
                            {dataPipeline?.applied ? "Applied" : "Not Applied"}
                        </Button>
                    </Tooltip>
                    <Button type="primary" onClick={triggerAIProcessor}>Trigger</Button>
                    <Button type="primary" onClick={retriggerAIProcessor}>Retrigger</Button>
                </Space>
            </Space>
        </Space>
    );
};

export default PipelineToolbar;
